import {SlctFormat} from 'component/Slct/SlctType'

export function getOptionLabel(displayFormat = SlctFormat.ValueLabel, value?: string | number | null, label?: string | number): string {
	if (!value && value !== 0) return ''
	if (!label && label !== 0) label = ''
	label += ''
	if (!label) return `${value}`
	switch (displayFormat) {
		case SlctFormat.ValueLabel:
			return `${value} - ${label}`
		case SlctFormat.Value:
			return `${value}`
		default:
		case SlctFormat.Label:
			return `${label}`
		case SlctFormat.LabelValue:
			return `${label} (${value})`
	}
}